import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { ApiResult } from 'idk/data/api-result';
import { DataRepository } from 'idk/data/data-repository';
import { ObservableWrapperService } from 'idk/services/observable-wrapper.service';
import { Observable, tap, map } from 'rxjs';
import { IMenu } from './menu.interface';
import { UserProfileService } from 'idk/services/security/user-profile.service';

@Injectable()
export class MenuBuilderService extends DataRepository {
    protected api: string = 'api/security/menu';

    public constructor(
        private _profile: UserProfileService,
        protected http: HttpClient,
        ow: ObservableWrapperService
    ) {
        super(ow);
    }

    public get(): Observable<Navigation> {
        return this.http
            .get<ApiResult<IMenu>>(this.buildApiCall(this._profile.role ?? ''), this.buildOptions())
            .pipe(
                tap((r) => this.process(r)),
                map((r) => ({
                    default: r.data?.items,
                    compact: r.data?.items,
                    futuristic: r.data?.items,
                    horizontal: r.data?.items,
                }))
            );
    }
}
